'use client';

import {
  Box,
  Button,
  Divider,
  IconButton,
  SystemIcon,
  Typography,
} from '@wishket/design-system';
import { twMerge } from 'tailwind-merge';
import { FormEvent, PropsWithChildren, ReactNode } from 'react';

interface CollectionModalContainerProps extends PropsWithChildren {
  title: string;
  className?: string;
  submitButtonText: string;
  bottomStickyElement?: ReactNode;
  onClose: () => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
}

const CollectionModalContainer = ({
  title,
  children,
  className,
  bottomStickyElement,
  submitButtonText,
  onClose,
  onSubmit,
}: CollectionModalContainerProps) => {
  return (
    <form
      className={twMerge(
        'flex h-full w-full flex-col desktop:max-h-[80vh]',
        className
      )}
      onSubmit={onSubmit}
    >
      <Box className="sticky top-0 z-[1] rounded-t-3xl bg-w-white">
        <Box className="relative flex items-center justify-center px-5 py-4 desktop:justify-start desktop:px-8 desktop:py-6">
          <Typography
            variant="subTitle1"
            className="font-medium desktop:typo-subTitle2"
          >
            {title}
          </Typography>
          <IconButton
            type="button"
            onClick={onClose}
            className="absolute right-5 top-1/2 -translate-y-1/2 transform desktop:right-8"
          >
            <SystemIcon name="large_delete" className="text-w-gray-600" />
          </IconButton>
        </Box>
        <Divider />
      </Box>

      <Box className="w-full flex-1 overflow-y-auto">{children}</Box>
      {bottomStickyElement && (
        <Box className="sticky bottom-0 z-[1]">{bottomStickyElement}</Box>
      )}
      <Box className="sticky bottom-0 z-[1] rounded-b-3xl bg-w-white">
        <Divider />
        <Box className="flex gap-4 px-5 py-4 desktop:justify-end desktop:px-8 desktop:pb-5 desktop:pt-[21px]">
          <Button
            variant="solid"
            className="w-1/2 border-w-bluegray-200 bg-w-bluegray-200 active:border-w-bluegray-300 active:bg-w-bluegray-300 hover:border-w-bluegray-300 hover:bg-w-bluegray-300 desktop:w-[89px]"
            onClick={onClose}
            type="button"
          >
            닫기
          </Button>
          <Button
            variant="solid"
            className="w-1/2 desktop:w-[89px]"
            type="submit"
          >
            {submitButtonText}
          </Button>
        </Box>
      </Box>
    </form>
  );
};

export default CollectionModalContainer;
